// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import ConfigHandler from 'core/loaders/handlers/ConfigHandler';
import Speech from './Speech';
import ObjectUtils from 'core/util/ObjectUtils';
import SpeechManager from './SpeechManager';

class SpeechHandler extends ConfigHandler {
  constructor(...args) {
    super(...args);
    this._speechManager = SpeechManager.getInstance();
  }

  _remove(ref) {
    const speech = this._objects.get(ref);
    if (!speech) {
      return;
    }

    speech.stop();
    this._objects.delete(ref);
  }

  _prepare(config) {
    ObjectUtils.defaults(config, {
      name: 'Speech',
      volume: 1.0,
    });
  }

  _create() {
    return new Speech(this._speechManager);
  }

  _update(ref, config, options) {
    return super._update.call(this, ref, config, options).then(speech => {
      if (!speech) {
        return;
      }

      // Delete default voice so it doesn't override the set voice
      delete config["voice"];

      speech.updateConfig(config);
      return speech;
    });
  }
}

ConfigHandler._registerClass('speech', SpeechHandler);

export default SpeechHandler;
